import React from 'react';
import {View, Text, StyleSheet} from 'react-native';
import {FONT_FAMILY, FONT_FAMILY_BOLD} from "../../constants/styleConstants";
import {translate} from '../../services/helpers/translate';
import {formatTimeFromMoment} from "../../services/helpers/dateTimeHelpers";
import moment from "moment";
import {actuatedNormalize} from "../../services/helpers/stylingHelpers";
import {useSelector} from "react-redux";
import {getConnectionStatus, getMaintenance, getNextBooking, getConfig} from "../../reducers/configSlice";

const NextBookingDetails = () => {
    const nextBooking = useSelector(getNextBooking)
    const config = useSelector(getConfig)
    const connectionStatus = useSelector(getConnectionStatus)
    const maintenance = useSelector(getMaintenance)

    return !config.hide_next_booking && !maintenance && (
        <View style={[styles.nextBookingContainer, !connectionStatus && {opacity: 0.6}]}>
            <Text style={[styles.nextBookingDetails, {color: '#9FADB1'}]}>
                {translate("Next") + ": "}
                <Text numberOfLines={1} ellipsizeMode="tail" style={styles.nextBookingDetails}>
                    {nextBooking ? nextBooking.title : translate("No future bookings for today") + "."}
                </Text>
            </Text>
            <Text style={[styles.nextBookingDetails, {fontFamily: FONT_FAMILY}]}>
                {nextBooking ? `${formatTimeFromMoment(moment(nextBooking.start))} - ${formatTimeFromMoment(moment(nextBooking.end))}` : null}
            </Text>
        </View>
    );
};

const styles = StyleSheet.create({
    nextBookingContainer: {
        flex: 0.14,
        width: '80%',
    },
    nextBookingDetails: {
        fontFamily:FONT_FAMILY_BOLD,
        color: '#FFFFFF',
        fontSize: actuatedNormalize(16)
    }
});

export default NextBookingDetails;
